import { PayloadAction } from '@reduxjs/toolkit';

import { setNumberValue } from '../../logic/value';
import { WritableAutoConfiguratorState } from '../slice';

type Payload = {
  lineItemUuid: string;
};

export function deleteLineItem(
  state: WritableAutoConfiguratorState,
  { payload: { lineItemUuid } }: PayloadAction<Payload>,
) {
  // Fetch line
  const line = state.lineItems[lineItemUuid];

  // Delete quantity breaks from state
  for (const uuid of line.quantityBreakUuids) {
    delete state.quantityBreaks[uuid];
  }

  // Delete line from Uuids
  const index = state.lineItemUuids.indexOf(lineItemUuid);
  state.lineItemUuids.splice(index, 1);

  // Delete line from state
  delete state.lineItems[lineItemUuid];
  delete state.calculationErrorsByLineItemUuid[lineItemUuid];

  // Re-number lines after the one that was deleted
  for (let i = index; i < state.lineItemUuids.length; i++) {
    setNumberValue(state.lineItems[state.lineItemUuids[i]].lineNumber, i + 1);
  }
}
